import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import withFieldsCheck from "@clarion/foundation/dist/Helpers/containers/WithFieldsCheck/index";
import ModalImagery from "@clarion/foundation/dist/Helpers/components/ModalImagery";
import ModalPanel from "@clarion/foundation/dist/Helpers/containers/ModalPanel";
import { toggleUnlockAccountModal } from "@clarion/foundation/dist/Settings/actions/globalActions";
import ModalSteps from "./ModalSteps";
import "@clarion/foundation/dist/Theming/styles/forms.css";
import "@clarion/foundation/dist/Theming/styles/account.css";
const UnlockAccountModal = ({
  fields,
  sitecoreContext,
  rendering
}) => {
  const unlockAccountFeatureToggle = sitecoreContext.unlockAccountSettings?.unlockAccountEnabled;
  const modal = useSelector(state => state.modal);
  const [stepNumber, setStepNumber] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const closeModal = () => {
    dispatch(toggleUnlockAccountModal(false));
    setIsOpen(false);
    window.sessionStorage.removeItem("loginEmail");
    setTimeout(() => {
      // Timeout to prevent first step from flashing up as modal closes
      setStepNumber(1);
    }, 500);
  };
  const afterClose = () => {
    if (!global.isTablet && window.sessionStorage.getItem("refocusNav") === "true") {
      window.document.getElementsByClassName("navigation__trigger")[0].focus();
      window.sessionStorage.removeItem("refocusNav");
    }
  };
  const proceedToNextStep = () => {
    setStepNumber(stepNumber + 1);
  };
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("openUnlockAccount") === "true") {
      setIsOpen(true);
    }
  }, []);
  if (!unlockAccountFeatureToggle) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ModalPanel, {
    isOpen: modal.isUnlockAccountOpen || isOpen,
    onClose: closeModal,
    contentLabel: fields.ModalTitle?.value,
    closeClassName: "account__close",
    afterClose: afterClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "account account--unlock"
  }, /*#__PURE__*/React.createElement("div", {
    className: "account__primary-content"
  }, /*#__PURE__*/React.createElement(ModalImagery, null), /*#__PURE__*/React.createElement(ModalSteps, {
    fields: fields,
    rendering: rendering,
    stepNumber: stepNumber,
    proceedToNextStep: proceedToNextStep
  }))));
};
const UnlockAccountModalWithFieldsCheck = withFieldsCheck(UnlockAccountModal);
export default withSitecoreContext()(UnlockAccountModalWithFieldsCheck);